import { useState, useRef } from "react"
import PropTypes from "prop-types"
import { Popover } from "@mui/material"
import FilterButton from "./filter-button"

import "./styles.scss"

export default function Filters({ filters, filterForm }) {
  const [open, setOpen] = useState(false)
  const buttonRef = useRef()

  return <div ref={buttonRef} className="component_table-filters">
    <FilterButton filters={filters} onClick={() => setOpen(true)} />
    <Popover
      anchorEl={buttonRef.current}
      open={open}
      disablePortal
      onClose={() => setOpen(false)}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <div className="filter-form-container">
        {filterForm}
      </div>
    </Popover>
  </div>
}

Filters.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.func),
  filterForm: PropTypes.node.isRequired,
}
